<div class="julian-date-tile">
  <div class="julian-header">Today's Julian Date</div>
  <div [style.font-size]="config.font_size + 'vmin'">{{julian_date}}</div>
</div>
